export const endDate = new Date('April 17, 2023 4:00:00 PM GMT+5:30');
